import * as actions from './organizar.action';
import inicialState from './organizar.state';

const organizarReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.ORGANIZAR_ATUALIZAR_LOTE_LAMINAS:
      return {
        ...state,
        laminas: action.payload.laminas,
      };
    case actions.ORGANIZAR_ATUALIZAR_MOVER_DISABLED:
      return {
        ...state,
        moverDisabled: action.payload.moverDisabled,
      };
    case actions.ORGANIZAR_ATUALIZAR_MODAL:
      return {
        ...state,
        modal: action.payload.modal,
      };
    case actions.ORGANIZAR_ATUALIZAR_NOVAS_LAMINAS:
      return {
        ...state,
        novasLaminas: action.payload.novasLaminas,
      };
    case actions.ORGANIZAR_ATUALIZAR_DESTINOS:
      return {
        ...state,
        destinos: action.payload.destinos,
      };
    case actions.ORGANIZAR_ATUALIZAR_LISTA:
      return {
        ...state,
        lista: action.payload.lista,
      };
    default:
      return state;
  }
};

export default organizarReducer;



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/store/organizar.reducer.js